/* eslint-disable import/no-unused-modules */
import { useQuery } from '@apollo/client';
import LinearProgress from '@mui/material/LinearProgress';
import dynamic from 'next/dynamic';
import React from 'react';
import { GET_GEOJSON } from '../../helpers/graphql/geojson';
import BlogTab from './BlogTab';
import TabPanel from './TabPanel';

const MapTab = dynamic(() => import('./MapTab'), {
  ssr: false,
  loading: () => <LinearProgress />,
});

export default function ProfileTabs({
  value,
  countryCodes,
  userPosts,
  profile,
  itineraries,
  isMini,
}) {
  // Post locations resolve client-side after mount — only the Map tab
  // depends on them, so only the Map tab waits.
  const { data } = useQuery(GET_GEOJSON, {
    variables: { countryList: countryCodes },
    skip: !countryCodes || countryCodes.length === 0,
  });

  return (
    <>
      <TabPanel value={value} index={0}>
        <BlogTab profile={profile} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        {value === 1 &&
          (data && data.geojson ? (
            <MapTab geojson={data.geojson} posts={userPosts} isMini={isMini} />
          ) : countryCodes && countryCodes.length === 0 ? (
            <p className="tw-py-16 tw-text-center tw-text-[15px] tw-text-[#5F6F69] dark:tw-text-[#93A69E]">
              No posts with locations yet.
            </p>
          ) : (
            <div className="tw-mx-auto tw-max-w-5xl tw-px-4 tw-py-10">
              <div className="tw-h-[420px] tw-animate-pulse tw-rounded-2xl tw-bg-[#EDE7D8] dark:tw-bg-[#26382F]" />
            </div>
          ))}
      </TabPanel>
      {itineraries && itineraries.length > 0 && (
        <TabPanel value={value} index={2}>
          <BlogTab profile={profile} itineraries={itineraries} />
        </TabPanel>
      )}
    </>
  );
}
